import { AxiosResponse } from "axios";
import { VehicleForBookingResponse } from "../types/api.types";
import { AxiosService } from "./axios.service";

const axiosService = AxiosService.getInstance();

export interface GetVehiclesRequest {
  pickupAddress: string;
  dropoffAddress: string;
  tripType?: 'one-way' | 'return';
}

export interface LocationCoordinates {
  lat: number;
  lng: number;
}

export interface GetVehiclesResponse {
  vehicles: VehicleForBookingResponse[];
  total: number;
  page: number;
  limit: number;
  distance: number; // in miles
  duration: number; // in seconds
  pickupCoords: LocationCoordinates;
  dropoffCoords: LocationCoordinates;
}

export interface CreateVehicleRequest {
  name: string;
  code: string;
  description?: string;
  seats: number;
  transmission: string;
  imageUrl?: string;
  segmentId: string;
  basePrice: number;
  currency: string;
}

export class VehicleService {
  getVehiclesForBookings(data: GetVehiclesRequest): Promise<AxiosResponse<GetVehiclesResponse>> {
    const url = "/bookings/vehicles";
    return axiosService.post<GetVehiclesResponse>(url, data);
  }

  // Create a new vehicle
  createVehicle(data: CreateVehicleRequest, token: string): Promise<AxiosResponse<VehicleForBookingResponse>> {
    const url = "/vehicles";
    return axiosService.postWithToken<VehicleForBookingResponse>(url, data, token);
  }

  // Get all vehicles with pagination and filters
  getAllVehicles(params: {
    page?: number;
    limit?: number;
    segmentId?: string;
    transmission?: string;
    minSeats?: number;
    maxSeats?: number;
    isActive?: boolean;
  }, token: string): Promise<AxiosResponse<{
    vehicles: VehicleForBookingResponse[];
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  }>> {
    const url = "/vehicles";
    return axiosService.getWithToken(url, params, token);
  }

  // Get a single vehicle by ID
  getVehicleById(id: string, token: string): Promise<AxiosResponse<VehicleForBookingResponse>> {
    const url = `/vehicles/${id}`;
    return axiosService.getWithToken<VehicleForBookingResponse>(url, {}, token);
  }

  // Legacy method - keeping for backward compatibility
  getVehiclesWithPriceAndCategory(locations: string[]): Promise<AxiosResponse<VehicleForBookingResponse[]>> {
    if (locations.length >= 2) {
      // Note: This will require a token, caller needs to provide it
      throw new Error("This method is deprecated. Use getVehiclesForBookings with token instead.");
    }
    throw new Error("Invalid locations data");
  }
}
